import React from 'react';
import PropTypes from 'prop-types';

// must be defined outside of the component to avoid re-rendering loops
const defaultStyle = {};
const Loader = _ref => {
  let _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$loaded = _ref.loaded,
    loaded = _ref$loaded === void 0 ? false : _ref$loaded,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? defaultStyle : _ref$style,
    _ref$failed = _ref.failed,
    failed = _ref$failed === void 0 ? false : _ref$failed,
    _ref$failedMessage = _ref.failedMessage,
    failedMessage = _ref$failedMessage === void 0 ? 'Unable to load content' : _ref$failedMessage;
  let message = '';
  let className = null;
  let newChildren = children;
  if (failed) {
    newChildren = null;
    className = null;
    message = failedMessage;
  } else if (!loaded) {
    newChildren = null;
    className = 'loader';
    message = 'Loading...';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style,
    "data-testid": "loader"
  }, /*#__PURE__*/React.createElement("h3", null, message), newChildren);
};
Loader.propTypes = {
  children: PropTypes.node,
  loaded: PropTypes.bool,
  failed: PropTypes.bool,
  failedMessage: PropTypes.string,
  style: PropTypes.shape({})
};
export default Loader;